// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2IaR_","downloadText":"_1QhSI","download":"_1HiuC","linkWeight":"_2S_Kh"};